//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DiscordPreFlightCheck from 'core/components/discord-pre-flight-check.vue'
import TwitchPreFlightCheck from 'core/components/twitch-pre-flight-check.vue'

export default {
    name: 'DebutStreamDetails',

    props: {
        flavor: {
            type: Object,
            required: true,
        },
    },

    methods: {
        goTwitch() {
            this.$vuedals.close(this)
            this.$present(TwitchPreFlightCheck)
            this.trackJoin('twitch::leah')
        },

        goDiscord() {
            this.$vuedals.close(this)
            this.$present(DiscordPreFlightCheck)
            this.trackJoin('discord')
        },

        trackJoin(category) {
            this.$gtag.event(`debut-join-${this.flavor.id}-${category}`)
        },
    },
}
